module.exports = {
  BUSINESS_DEVELOPMENT: 'business-development',
  CORPORATE: 'corporate',
  CUSTOMER_SUPPORT: 'customer-support',
  ENGINEERING: 'engineering',
  FINANCE: 'finance',
  GROWTH_AND_MARKETING: 'growth-and-marketing',
  OPERATIONS: 'operations',
  OTHER: 'other',
};
